<!--
* @FileDescription: table展示
*父组建中使用方法调取方法参考:
*import TableList from '@/components/TableList/index'
<table-list
    :table-loading="isQuerying"
    :table-data="tableData"
    :table-header="tableHeader"
    :is-check-all="isCheckAll"
    :chkstu="chkstu"
    :checkchange="checkChange"
    :row-click="handle"
    :cell-click="cellClick"
    :page="page"
    :page-size-click="handleSizeChange"
    :page-num-click="handleCurrentChange"
>
    <template slot-scope="scopeData">
            <el-button
                v-if="scopeData.row.status === 0 && scopeData.row.processStatus !== 1&&$has('4s:factory:material-manage-detail')"
                type="text"
                @click.stop="gotoDetail(scopeData.row.id, 'edit')">
                编辑
            </el-button>
        </template>
</table-list>
//表格数据
tableData:[],
//是否需要显示全选框
isCheckAll:true,
//是否需要分页组建
isPagination:true,
//表头、对应的字段名、列属性
//表头
tableHeader:[
    {label:'配件编码',prop:'materialNo',special:true,show:true,width:"120px",checkBox:true},
    {label:'旧件是否返司',prop:'oldReturnFlag',show:true,width:"100px",
        statusArray:[
            {typeValue:1,typeName:"是"},
            {typeValue:0,typeName:"否"}
        ]
    },
    {label:'适用车型',prop:'matchTruckModelCode',show:true,width:"80px",statusArray:[],cellClick:true},
    {label:'发票图片证明',show:true,picUrl:'https://img.31truck.com/3433248456919e829ed900a91f461f70',width:"180px"},
    {label:"操作",width:"200px",fixed:"right",show:true}
],
//分页
page: {
    pageNum: 1,
    pageSize: 10,
    total: null
},

/**
* 点击单元格
*/
cellClick(row, column, cell, event){
},

/**
* 改变页码
* @param pageNum 新页码
*/
handleCurrentChange(pageNum) {
    this.page.pageNum = pageNum;
    this.getList();
},
/**
* 改变每页显示条数
* @param pageSize 新页码大小
*/
handleSizeChange(pageSize) {
    this.page.pageNum = 1;
    this.page.pageSize = pageSize;
    this.getList();
}
/**
* 复选框改变
*/
checkChange(val){
    this.checkedList = [];
    val.length &&
        val.forEach((item) => {
            this.checkedList.push(item.id);
        });
},
/**
* 列表复选框是否可点击
*/
chkstu(row) {
    return (row.status === 'WAIT_FOR_DISTRIBUTION' &&  !row.totalAmount) ? true : false;
},
-->
<template>
    <div>
        <el-table
            v-loading="tableLoading"
            :data="tableData"
            :row-key="rowKey"
            :expand-row-keys="expandedRowKeys"
            :row-class-name="tableRowClassName"
            :cell-class-name="tableCellClassName"
            :border="ifBorder"
            v-bind="$attrs"
            v-on="$listeners"
            @selection-change="checkchange"
            @row-click="rowClick"
            @cell-click="cellClick"
        >
            <!-- 如果是展开类型表格，添加展开列 -->
            <el-table-column
                v-if="type === 'expand'"
                type="expand"
                width="50"
            >
                <template slot-scope="props">
                <slot name="expand" :row="props.row"></slot>
                </template>
            </el-table-column>
            <!-- 是否需要整列显示复选框-->
            <el-table-column
                v-if="isCheckAll"
                type="selection"
                align="center"
                :selectable="chkstu"
                fixed
                @selection-change="checkchange"
            ></el-table-column>
            <!-- 是否展示序号列 -->
            <el-table-column v-if="isIndex" type="index" label="序号" width="50" fixed></el-table-column>
            <template v-for="(item, index) in tableHeader">
                <el-table-column
                    v-if="item.show === undefined || item.show"
                    :key="index"
                    :resizable="false"
                    :label="item.label"
                    align="center"
                    :width="item.width"
                    :min-width="item.minWidth"
                    :max-width="item.maxWidth"
                    :fixed="item.fixed"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <div v-if="item.prop && item.special === undefined" :class="item.prop + scope.row[item.prop]">
                            {{ statusFormatter(scope.row, item.prop, item.statusArray, scope.$index) }}
                        </div>
                        <!-- 操作按钮 -->
                        <slot
                            v-else-if="
                                (item.prop === undefined && item.picUrl === undefined) || (item.prop && item.special)
                            "
                            :row="scope.row"
                            :index="scope.$index"
                        ></slot>
                        <!-- 单元格中展示图片 -->
                        <el-image
                            v-if="item.prop === undefined && item.picUrl"
                            class="main-cover"
                            :src="scope.row.picUrl"
                            :preview-src-list="[scope.row.picUrl]"
                        >
                        </el-image>
                        <!-- 自定义显示 -->
                        <slot
                            v-if="item.slot"
                            :row="scope.row"
                            :name="item.slot"
                            :column="item"
                            :index="scope.$index"
                        ></slot>
                    </template>
                </el-table-column>
            </template>
        </el-table>
        <sy-pagination
            v-if="page !== undefined && tableData.length"
            :page-num="page.pageNum"
            :page-size="page.pageSize"
            :total="page.total"
            @current-change="pageNumClick"
            @size-change="pageSizeClick"
        />
    </div>
</template>
<script type="text/ecmascript-6">
export default {
    name: 'TableList',
    props: {
        //表格数据
        tableData: {
            type: Array,
            default: function () {
                return [];
            }
        },
        //表头、对应的字段名、列属性
        tableHeader: {
            type: Array,
            default: function () {
                return [];
            }
        },
        //是否需要显示全选框
        isCheckAll: {
            type: Boolean,
            default: false
        },
        //复选框是否可点击
        chkstu:{
            type: Function,
            default: function (row, index) {
                return true
            }
        },
        //复选框状态变化
        checkchange:{
            type: Function,
            default: function (val) {}
        },
        //是否展示序号列
        isIndex:{
            type:Boolean,
            default:false
        },
        //加载等待
        tableLoading: {
            type: Boolean,
            default: false
        },
        //单行点击事件
        rowClick: {
            type: Function,
            default: function (row, event, column) {}
        },
        //单元格点击事件
        cellClick:{
            type: Function,
            default: function (row, event, column) {}
        },
        //分页
        page:{
            type:Object,
            default:function(){
                return {};
            }
        },
        //页面点击
        pageNumClick: {
            type: Function,
            default: function (pageNum) {}
        },
        //页面展示条数
        pageSizeClick: {
            type: Function,
            default: function (pageSize) {}
        },
        //表格是否显示边框
        ifBorder:{
            type:Boolean,
            default:false
        },
        // 展开相关属性
        type: {
            type: String,
            default: '' // expand 或其他值
        },
        rowKey: {
            type: [String, Function],
            default: 'id'
        },
        expandedRowKeys: {
            type: Array,
            default: () => []
        }
    },
    computed:{},
    methods:{
        /**
         * 字典翻译
         */
        statusFormatter(row,prop,array,index){
            if(array!==undefined && array.length && row[prop]!==null){
                return this.$utils.filterMap(row[prop], array)
            }else{
                return row[prop]
            }
        },
        /**
         * 将前行索引放入row中
         */
        tableRowClassName({row,rowIndex}){
            row.rowIndex = rowIndex
        },
        /**
         * 将前列索引放入row中
         */
        tableCellClassName({row, column, rowIndex, columnIndex}){
            row.cellIndex = columnIndex;
        }
    }
};
</script>

<style rel="stylesheet/css" scoped>
.button-list > div {
    display: inline-block;
    margin: 0 5px;
}
/deep/ .pagination .el-pagination__jump .el-pagination__editor {
    width: 50px;
}
</style>
